// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMonthlyInvoicePath = 'M26 6h7v5h34V6h7v5h20v71.5A10.5 10.5 0 0183.5 93h-60C13.858 92.945 6.055 85.142 6 75.5V11h20V6zm57.5 80h-49a3.5 3.5 0 01-3.5-3.5V68H16.5a3.5 3.5 0 01-3.5-3.5V37h74v45.5a3.5 3.5 0 01-3.5 3.5zM87 30H13V18h13v4h7v-4h34v4h7v-4h13v12zM16.5 75c-1.227 0-2.405-.21-3.5-.597V75.5C13 81.299 17.701 86 23.5 86h1.1a10.497 10.497 0 01-.6-3.5V75h-7.5zM53 42h-6v5.368a10 10 0 00-5.9 4.532 7.9 7.9 0 00-1.2 4.2c0 5 4.5 9 10.1 9h1c1.8.3 3.1 1.5 3.1 2.9a2 2 0 01-.2 1 4.3 4.3 0 01-3.9 2 4.3 4.3 0 01-3.9-2l-5.4 2.5a10.1 10.1 0 006.3 5.14V81h6v-4.401c2.828-.774 5.179-2.607 6.3-4.999a8.6 8.6 0 00.8-3.6c0-4.3-3.4-8-8.1-8.8l-2-.2c-2.2 0-4.1-1.4-4.1-3a2.7 2.7 0 01.3-1.2 4.9 4.9 0 017.6 0l5.1-3a10 10 0 00-5.9-4.45V42z';
var IllustrationMonthlyInvoice = baseIllustration('IllustrationMonthlyInvoice', {
  getPath: () => IllustrationMonthlyInvoicePath
}, 'ColoredIllustrationMonthlyInvoice');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMonthlyInvoice;
//# sourceMappingURL=index.js.map